module.exports = __webpack_public_path__ + "static/media/barriers_to_literacy.12910214.png";